<template>
  <li data-test="sidebar-voce">
    <NuxtLink
      v-if="!èGruppo"
      :to="voce.route ?? '/'"
      :aria-current="attiva ? 'page' : undefined"
      :class="[RIGA, PADDING[livello], attiva ? 'bg-accent/20 font-medium hover:bg-accent/30' : 'hover:bg-text-primary/10 hover:translate-x-0.5']"
      data-test="sidebar-link"
      @click="emit('naviga')"
    >
      <span v-if="attiva" class="absolute inset-y-1.5 left-0 w-0.75 rounded-full bg-accent" aria-hidden="true" />
      <i :class="[voce.icon, ICONA, 'icon-hover-pop', attiva ? 'text-accent' : 'text-text-muted']" aria-hidden="true" />
      <span class="min-w-0 flex-1 leading-snug">
        <span v-if="voce.parent_label" class="block text-[10px] font-normal text-text-muted">{{ t(voce.parent_label) }}</span>
        {{ t(voce.label ?? "") }}
      </span>
    </NuxtLink>

    <template v-else>
      <button
        type="button"
        :aria-expanded="aperto ? 'true' : 'false'"
        :aria-controls="idFigli"
        :class="[RIGA, PADDING[livello], 'select-none', haAttivo ? 'bg-accent/10 hover:bg-accent/20' : 'hover:bg-text-primary/10 hover:translate-x-0.5']"
        data-test="sidebar-gruppo"
        @click="emit('alterna', voce.key)"
      >
        <i :class="[voce.icon, ICONA, 'icon-hover-pop', haAttivo ? 'text-accent' : 'text-text-muted']" aria-hidden="true" />
        <span class="min-w-0 flex-1 leading-snug">{{ t(voce.label ?? "") }}</span>
        <i
          class="fal fa-chevron-down shrink-0 text-[11px] text-text-muted transition-transform duration-(--motion-slow)"
          :class="aperto && 'rotate-180'"
          aria-hidden="true"
        />
      </button>
      <!-- Il gruppo si apre animando l'altezza (grid-rows); da chiuso è inert: i suoi link non si raggiungono con Tab -->
      <div
        :id="idFigli"
        class="grid transition-[grid-template-rows] duration-(--motion-slow) ease-(--ease-standard) motion-reduce:transition-none"
        :class="aperto ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'"
        :inert="aperto ? undefined : true"
        data-test="sidebar-figli"
      >
        <ul class="min-h-0 overflow-hidden">
          <SidebarVoce
            v-for="figlio in voce.items"
            :key="figlio.key"
            :voce="figlio"
            :livello="Math.min(livello + 1, 2)"
            :route-attiva="routeAttiva"
            :espansi="espansi"
            @alterna="(chiave: string) => emit('alterna', chiave)"
            @naviga="emit('naviga')"
          />
        </ul>
      </div>
    </template>
  </li>
</template>

<script setup lang="ts">
// Una voce del menu laterale: link, oppure gruppo che si apre e contiene altre voci (ricorsivo, fino a tre livelli). Il gruppo è
// un <button aria-expanded> collegato ai figli; il link della pagina corrente ha `aria-current="page"` oltre all'evidenza visiva.
import { useI18n } from "vue-i18n";
import { haFiglioAttivo, type VoceMenu } from "~/utils/menu";

const props = defineProps<{
  voce: VoceMenu;
  livello: 0 | 1 | 2;
  routeAttiva: string;
  espansi: Record<string, boolean>;
}>();

const emit = defineEmits<{ alterna: [chiave: string]; naviga: [] }>();
const { t } = useI18n();
const idFigli = `sidebar-figli-${useId()}`;

const èGruppo = computed(() => !!props.voce.items && props.voce.items.length > 0);
const attiva = computed(() => props.voce.route === props.routeAttiva);
const haAttivo = computed(() => haFiglioAttivo(props.voce, props.routeAttiva));
const aperto = computed(() => !!props.espansi[props.voce.key]);

const RIGA =
  "focusable relative flex w-full items-center gap-2.5 rounded-md py-2 pr-3 text-left text-sm text-text-primary no-underline transition-[color,background-color,translate] duration-(--motion-fast) max-lg:min-h-11";
const ICONA = "w-4.5 shrink-0 text-center text-[15px] transition-colors duration-(--motion-fast)";
const PADDING = { 0: "pl-3", 1: "pl-9", 2: "pl-12" } as const;
</script>
